
import React from 'react';
import { Clock, Edit, Image, Send, Check, MessageSquare, Loader2, Plus } from "lucide-react";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { useRecentActivities } from "@/hooks/use-tasks";
import { Button } from "@/components/ui/button";

export function RecentActivities() {
  const { activities, isLoading, error } = useRecentActivities();

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center h-32 w-full">
        <Loader2 className="h-6 w-6 text-primary animate-spin" />
        <p className="text-sm text-muted-foreground mt-2">Carregando atividades...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-32 w-full">
        <p className="text-sm text-muted-foreground">{error}</p>
        <Button variant="outline" size="sm" className="mt-2" onClick={() => window.location.reload()}>
          Tentar novamente
        </Button>
      </div>
    );
  }

  if (activities.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-32 w-full">
        <p className="text-sm text-muted-foreground">Não há atividades recentes</p>
      </div>
    );
  }

  // Função para obter o ícone baseado no tipo de atividade
  const getIcon = (iconName: string) => {
    switch (iconName) {
      case 'Send': return Send;
      case 'Check': return Check;
      case 'Edit': return Edit;
      case 'Image': return Image;
      case 'MessageSquare': return MessageSquare;
      case 'Plus': return Plus;
      default: return Clock;
    }
  };

  return (
    <div className="space-y-5">
      {activities.map((activity) => (
        <div key={activity.id} className="flex items-start space-x-3">
          <Avatar className="h-8 w-8">
            <AvatarFallback className="bg-primary/10 text-primary">
              {activity.user.initials}
            </AvatarFallback>
          </Avatar>
          <div className="flex-1 space-y-1">
            <div className="flex items-center gap-1 text-sm">
              <span className="font-medium">{activity.user.name}</span>
              <span>{activity.action}</span>
              <span className="font-medium">{activity.target}</span>
              {activity.client && (
                <span className="text-xs text-primary">({activity.client})</span>
              )}
            </div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground">
              <Clock className="h-3 w-3" />
              <span>{activity.formattedTime}</span>
            </div>
          </div>
          <div className={`rounded-full bg-background p-1.5 ${activity.iconColor.replace('text-', 'bg-')}/10`}>
            {React.createElement(getIcon(activity.icon), {
              className: `h-3.5 w-3.5 ${activity.iconColor}`,
            })}
          </div>
        </div>
      ))}
    </div>
  );
}
